import React from 'react';
import PropTypes from 'prop-types';
import Button from './Button';
import { formShell } from '../styles/formShell';

const buttonClassName = "w-full bp-lg:w-auto";

const FormActions = ({
    hasChanges = false,
    loading = false,
    onReset,
    onSave,
    resetLabel = 'リセット',
    saveLabel = '保存',
    loadingLabel = '更新中...',
    disabled = false,
    className = '',
    submitType = 'button', // 'button' or 'submit'
    bleed = true,
}) => {
    const isDisabled = disabled || loading || !hasChanges;
    const baseClass = bleed ? formShell.actionsBleed : formShell.actions;
    const finalClassName = [baseClass, className].filter(Boolean).join(' ');

    return (
        <div className={finalClassName}>
            {hasChanges && (
                <span className={formShell.actionsUnsaved} aria-live="polite">
                    未保存の変更があります
                </span>
            )}
            {onReset && (
                <Button
                    type="button"
                    variant="secondary"
                    size="lg"
                    onClick={onReset}
                    disabled={isDisabled}
                    className={buttonClassName}
                >
                    <span className="material-symbols-outlined">
                        undo
                    </span>
                    {resetLabel}
                </Button>
            )}
            {onSave && (
                <Button
                    type={submitType}
                    variant="primary"
                    size="lg"
                    onClick={submitType === 'button' ? onSave : undefined}
                    disabled={isDisabled}
                    className={buttonClassName}
                >
                    <span className="material-symbols-outlined">
                        save
                    </span>
                    {loading ? loadingLabel : saveLabel}
                </Button>
            )}
        </div>
    );
};

FormActions.propTypes = {
    hasChanges: PropTypes.bool,
    loading: PropTypes.bool,
    onReset: PropTypes.func,
    onSave: PropTypes.func,
    resetLabel: PropTypes.string,
    saveLabel: PropTypes.string,
    loadingLabel: PropTypes.string,
    disabled: PropTypes.bool,
    className: PropTypes.string,
    submitType: PropTypes.oneOf(['button', 'submit']),
    bleed: PropTypes.bool,
};

export default FormActions;
